export function hexToRgba(hex: string, alpha = 1) {
  const parsedHex = hex.replace(/^#/, "");

  if (parsedHex.length !== 6) {
    return hex;
  }

  const r = parseInt(parsedHex.slice(0, 2), 16);
  const g = parseInt(parsedHex.slice(2, 4), 16);
  const b = parseInt(parsedHex.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const getHexWithOpacity = (hex: string, opacity: number): string => {
  const alpha = Math.round((opacity / 100) * 255);
  const alphaHex = alpha.toString(16).padStart(2, "0");
  return `${hex}${alphaHex}`;
};
